export const getMovies = "getMovies";
export const getMovieDetail = "getMovieDetail";
export const GET_MOVIES = "GET_MOVIES";
export const GET_MOVIES_DETAIL = "GET_MOVIES_DETAIL";
export const ADD_MOVIE_FAVORITE = "ADD_MOVIE_FAVORITE";
export const REMOVE_MOVIE_FAVORITE = "REMOVE_MOVIE_FAVORITE";
